<template>
  <div>
    <Header :title="title"></Header>
  </div>
</template>

<script>
import { Api } from "../../../../utils/axios";

export default {
  data() {
    return {
      uuid: "",
      title: ""
    };
  },
  methods: {
    async getUuid() {
      const res = await Api.yktmk();
      this.uuid = res.data;

      if (this.title === "我的课程") {
        window.location.href =
          "https://appucloud.bupt.edu.cn/index.html#/pages/weAuth/weAuth?linkType=site&uuid=" +
          this.uuid;
      } else if (this.title === "课程作业") {
        window.location.href =
          "https://appucloud.bupt.edu.cn/index.html#/pages/weAuth/weAuth?linkType=assignment&uuid=" +
          this.uuid;
      } else if (this.title === "课程测验") {
        window.location.href =
          "https://appucloud.bupt.edu.cn/index.html#/pages/weAuth/weAuth?linkType=exam&uuid=" +
          this.uuid;
      } else if (this.title === "课程讨论") {
        window.location.href =
          "https://appucloud.bupt.edu.cn/index.html#/pages/weAuth/weAuth?linkType=forum&uuid=" +
          this.uuid;
      }
    }
  },
  created() {
    this.title = this.$route.query.title;
    this.getUuid();
  }
};
</script>



// WEBPACK FOOTER //
// src/components/newPages/teacher/yunClass/index.vue